import script from "./InlineCode.vue?vue&type=script&setup=true&lang=js"
export * from "./InlineCode.vue?vue&type=script&setup=true&lang=js"

import "./InlineCode.vue?vue&type=style&index=0&id=47931646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47931646"]])

export default __exports__